var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2222 8.31641C14.2222 11.7528 11.4364 14.5386 8 14.5386C4.56356 14.5386 1.77778 11.7528 1.77778 8.31641C1.77778 4.87997 4.56356 2.09418 8 2.09418C11.4364 2.09418 14.2222 4.87997 14.2222 8.31641ZM16 8.31641C16 12.7347 12.4183 16.3164 8 16.3164C3.58172 16.3164 0 12.7347 0 8.31641C0 3.89813 3.58172 0.316406 8 0.316406C12.4183 0.316406 16 3.89813 16 8.31641ZM7.99999 3.42752C8.49091 3.42752 8.88888 3.85865 8.88888 4.39048V7.98926L10.7247 9.82506C11.1065 10.2069 11.1347 10.7979 10.7875 11.145C10.4404 11.4921 9.84945 11.464 9.4676 11.0821L7.39342 9.00796C7.13471 8.74925 7.03836 8.39454 7.1111 8.08471V4.39048C7.1111 3.85865 7.50907 3.42752 7.99999 3.42752Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.d093dafeb5d8d891ea936365e15a816f.svg";
export { ForwardRef as ReactComponent };